module.exports = __webpack_public_path__ + "static/media/forbes.2fa5fe09.png";